var cancellationStatePrePromoCode = "";

(function($) {
	formHelper.addIPeerRule({
		// ID of the Payment form on the WWW site
		// No need to call out the form id inside the iframe
		// The selector 'form' is always used
		form: '#form-booking-step-1',
		status: {
			// SUCCESS is what we would do if BOTH the iframe cde
			// and the www forms are successful
			SUCCESS: '/book/review-your-reservation',
			SESSION_EXPIRED: '/book/session-expired',
			ERROR: function() {
				lDialog.close();
			}
		}
	});

	formHelper.addRule({
		form: '#form-booking-step-1-NoPayment',
		status: {
			SUCCESS: '/book/review-your-reservation',
			SESSION_EXPIRED: '/book/session-expired',
			ERROR: function() {
				lDialog.close();
			}
		},
		xhrReady: function(xhrOptions) {
			xhrOptions.data['peer-status'] = 'SUCCESS';
		}
	});

})(jQuery);

jQuery(function initHandleBookingStep1Form($) {
	$('.form-booking-step-1').each(function(index, el) {

		var $container             = $(this);
		var $form                  = $container.find('.form-booking-step-1');
		var $submitBtn             = $container.find('.btn-submit');
		var $applyPromoBtn         = $container.find('.btn-apply-promocode');
		//var $removePromoBtn        = $container.find('.btn-remove-promocode');
		var $removePromoBtn        = $('body').find('.js-remove-promocode');
		var $applyCouponBtn        = $container.find('.btn-apply-coupon');

		// Get the Final Price 
		//(using an each because the summary is presented twice for responseive purposes)
		var finalPrice = getFinalPrice();
		validateIsNoPaymentBookingForm(finalPrice);

		$submitBtn.click(function() {
			// Diaplay a lDialog loading shadow box
			checkValidityValue = $('.form-booking-step-1')[0].checkValidity(); // returns true/false

			if(checkValidityValue === true) {
				// Browser checkValidity is true, load loading ldialog shadow box
				launchLoadingDialog();
			}
		});

		$applyPromoBtn.click(function() {

			if($('#js-cancel-policy-normal').hasClass('cancel-policy-hidden') && cancellationStatePrePromoCode === ''){
				cancellationStatePrePromoCode = 'canceldisabled';
			}
			else if($('#js-cancel-policy-normal').hasClass('cancel-policy-visible') && cancellationStatePrePromoCode === ''){
				cancellationStatePrePromoCode = 'cancelenabled';
			}

			promocode = $('#promocode').val();

			if(promocode !== '') {
				$.ajax({
					method: "POST",
					url: "/h/book/ApplyPromoCode",
					dataType: 'JSON',
					data: { promocode: promocode },
				})
				.done(function( data ) {
					if (data.validPromo === 'yes') {
						// Success
						// Turn off
						$('.js-fh-error-invalid-promocode').css('display','none');
						$('.js-promocode-apply').css('display','none');

						// Turn on
						$('.js-promocode-name').html(promocode);
						$('.js-promocode-discount-amount').html(data.promocodeDiscount);
						$('.js-sub-total').html(data.subTotal);
						$('.js-tax-amount').html(data.taxAmount);
						$('.js-final-price').html(data.finalPrice);

						recalculateGrandTotalPrice();

						$('.js-promocode-remove').css('display','inline');
						$('.js-promocode-applied').css('display','block');
						$('.js-promocode-discount-summary').css('display','block');

						// If the promo code is not cancellable, update cancellation policy
						if(data.allowCancel === 'N'){
							// Cancel is showing as enabled, but we need to disable it
							$('#js-cancel-policy-normal').addClass('cancel-policy-hidden');
							$('#js-cancel-policy-cancel').removeClass('cancel-policy-hidden');

							// Show the cancellation checkbox
							$('#js-cancel-checkbox').removeClass('cancel-policy-hidden');
						}

						// If the Online Booking Discount was applied, show it
						if (typeof $('.js-online-booking-discount') !== 'undefined') {
							if (data.allowSpaceADiscount === 'N') {
								$('.js-online-booking-discount').hide();
							}
						}

						// Reload CDE iframe to set creditCardTypes
						refreshPeerIframeSrc(data.creditCardTypes);

						// Validate the Booking form name
						validateIsNoPaymentBookingForm(data.finalPrice);
					} else {
						$('.js-fh-error-invalid-promocode').css('display','block');
					}
				})
				.fail(function() {
					alert( "An unexpected error has occurred." );
				});
			}
		});

		$removePromoBtn.click(function() {
			promocode = $('#promocode').val();
		
			$.ajax({
				method: "POST",
				url: "/h/book/RemovePromoCode",
				dataType: 'JSON',
			})
			.done(function( data ) {
				// Success
				// Restore
				$('.js-promocode-applied').css('display','none');
				$('.js-promocode-discount-summary').css('display','none');
				$('#promocode').val('');

				// Apply
				$('.js-sub-total').html(data.subTotal);
				$('.js-tax-amount').html(data.taxAmount);
				$('.js-final-price').html(data.finalPrice);

				recalculateGrandTotalPrice();

				$('.js-promocode-apply').css('display','block');

				if(cancellationStatePrePromoCode !== 'canceldisabled'){
					$('#js-cancel-policy-normal').removeClass('cancel-policy-hidden');
					$('#js-cancel-policy-cancel').addClass('cancel-policy-hidden');
				}
				else {
					$('#js-cancel-policy-normal').addClass('cancel-policy-hidden');
					$('#js-cancel-policy-cancel').removeClass('cancel-policy-hidden');
				}
				
				// Handle the cancellation checkbox
				if(cancellationStatePrePromoCode !== 'canceldisabled'){
					// If cancellation was not disabled before starting the promo process, hide the box
					$('#js-cancel-checkbox').addClass('cancel-policy-hidden');
				}

				// If the Online Booking Discount was applied, show it
				if (typeof $('.js-online-booking-discount') !== 'undefined') {
					$('.js-online-booking-discount').show();
				}

				// Reload CDE iframe to restore creditCardTypes
				refreshPeerIframeSrc($('#credit-card-types').val());

				// Validate the Booking form name
				validateIsNoPaymentBookingForm(data.finalPrice);
			})
			.fail(function() {
				alert( "An unexpected error has occurred." );
			});
		});

		// Coupon Actions Below

		$applyCouponBtn.click(function() {
			$('.js-fh-success-coupon-applied').css('display','none');
			couponValue = $('#coupon-value').val();

			if(couponValue !== '') {
				$.ajax({
					method: "POST",
					url: "/h/book/ApplyCoupon",
					dataType: 'JSON',
					data: { couponValue: couponValue },
				})
				.done(function( data ) {
					// Success - Process
					$('.js-coupon-discount-amount').html(data.couponDiscount);
					$('.js-sub-total').html(data.subTotal);
					$('.js-tax-amount').html(data.taxAmount);
					$('.js-final-price').html(data.finalPrice);

					recalculateGrandTotalPrice();

					finalPriceNum = data.finalPrice.replace("$", "");

					if (parseInt(finalPriceNum, 10) > 0) {
						// Turn off / Clear
						$('.js-fh-error-coupon-error').css('display','none');

						// Turn on and populate values
						$('.js-fh-success-coupon-applied').css('display','block');
					} else {
						// Turn off / clear
						$('.js-fh-success-coupon-applied').css('display','none');

						// Turn on - Zero priced inventory, display coupon error
						$('.js-fh-error-coupon-error').css('display','block');
					}
				})
				.fail(function() {
					alert( "An unexpected error has occurred." );
				});
			}
		});

		function getFinalPrice() {
			// Get the Final Price 
			//(using an each because the summary is presented twice for responseive purposes)
			var finalPrice = '';
			$('.js-final-price').each(function(index, obj){
				// grab the last class value
				finalPrice = $(this).text();
				finalPrice = finalPrice.replace(",", "");
			});

			return finalPrice;
		}

		function validateIsNoPaymentBookingForm(finalPrice) {
			// Check if the form should be a no cost submission
			finalPriceNum = finalPrice.replace("$", "");
			//alert("finalPriceNum:" + finalPriceNum);
			var $isAIPurchase = $("#js-ai-flag");
			var $isPremiumPurchase = $("#is-premium-purchase");
			
			if (parseInt(finalPriceNum, 10) === 0) {
				// Rename form id to submit the NoPayment FH addRule
				if($("#form-booking-step-1").length > 0) {
					$('#form-booking-step-1').attr('id','form-booking-step-1-NoPayment');
					//alert("Makes it here: NOW NoPayment form ID");
				}

				// Remove NoPayment Info section
				$('.js-billing-information-block').css('display','none');
				$('.js-payment-information-block').css('display','none');

				// Remove required attributes
				$("#first-name-b").prop("required", false);
				$("#last-name-b").prop("required", false);
				$("#address1-b").prop("required", false);
				$("#city-b").prop("required", false);
				$("#state-province-b").prop("required", false);
				$("#postalcode-b").prop("required", false);
				$("#country-b").prop("required", false);
				$("#phone-b").prop("required", false);

				// Update Step Count - decrement
				if($isAIPurchase.html() === 'yes'){
					$('.js-all-inclusive-info-count').text('2');
					$('.js-urgent-info-count').text('3');
				}
				else {
					$('.js-urgent-info-count').text('2');
				}

			} else {
				// Rename form id to submit without NoPayment FH addRule
				if($('#form-booking-step-1-NoPayment').length > 0) {
					$('#form-booking-step-1-NoPayment').attr('id','form-booking-step-1');
					//alert("Makes it here: Restored form ID");
				}

				// Restore NoPayment Info section
				$('.js-billing-information-block').css('display','block');
				$('.js-payment-information-block').css('display','block');

				// Add required attributes
				$("#first-name-b").prop("required", true);
				$("#last-name-b").prop("required", true);
				$("#address1-b").prop("required", true);
				$("#city-b").prop("required", true);
				$("#state-province-b").prop("required", true);
				$("#postalcode-b").prop("required", true);
				$("#country-b").prop("required", true);
				$("#phone-b").prop("required", true);

				// Update Step Count - restore

				if($isAIPurchase.html() === 'yes'){
					$('.js-all-inclusive-info-count').text('4');
					$('.js-urgent-info-count').text('5');
				}
				else {
					if($isPremiumPurchase.val() === 'yes') {
						$('.js-urgent-info-count').text('6');
					}
					else {
						$('.js-urgent-info-count').text('4');
					}	
				}
			}
		}

		jQuery(function($) {
			// Same as traveler info checkbox feature to copy and populate traveler info
			$('[name="same-as-traveler-info"]').click( function() {
				if($(this).is(':checked')) {
					$('#first-name-b').val($('#first-name').val());
					$('#last-name-b').val($('#last-name').val());
					$('#address1-b').val($('#address1').val());
					$('#address2-b').val($('#address2').val());
					$('#city-b').val($('#city').val());
					$('#state-province-b').val($('#state-province').val());
					$('#postalcode-b').val($('#postalcode').val());
					$('#country-b').val($('#country').val());
					$('#phone-b').val($('#phone').val());
				}
			});
		});

		jQuery(function($) {
			// Set the form with evrBookingAlert when populated
			var $evrBookingAlertContent = $('.evrBookingAlertContent').text();

			if($evrBookingAlertContent !== '') {
				$(document).ready(function(){
					$("#evrBookingAlert").trigger("click");
				});
			}
		});


		// Membership Price Actions Below

		jQuery(function($) {
			var $isPremiumPurchase = $("#is-premium-purchase");
			var $isAIPurchase = $("#js-ai-flag");
			var finalPrice = getFinalPrice();
			finalPriceNum = finalPrice.replace("$", "");
			
			if($isPremiumPurchase.val() === 'yes') {
				// Update Step Count
				$('.js-premium-membership-upgrade-count').text('3');
				$('.js-premium-membership-referral-count').text('4');
				$('.js-payment-information-count').text('5');

				if($isAIPurchase.html() === 'yes' && parseInt(finalPriceNum, 10) > 0) {
					$('.js-all-inclusive-info-count').text('6');
					$('.js-urgent-info-count').text('7');
				}
				else if(parseInt(finalPriceNum, 10) > 0){
					$('.js-urgent-info-count').text('6');
				}
			}
			else {
				$('.js-payment-information-count').text('3');
				
				if(parseInt(finalPriceNum, 10) > 0){
					if($isAIPurchase.html() === 'yes'){
						$('.js-all-inclusive-info-count').text('4');
						$('.js-urgent-info-count').text('5');
					}
					else {
						$('.js-urgent-info-count').text('4');
					}
				}
			}
		});

		$(function(){
			$('input[name="membership-id"]:radio').change(function() {
				ajaxApplyMembershipPrice('price');
			});
		});

		$(function(){
			$('#state-province-b').on('change', function() {
				ajaxApplyMembershipPrice('state');
			});
		});

		function ajaxApplyMembershipPrice($status) {
			membershipID = $('input[name=membership-id]:checked', '.form-booking-step-1').val();
			stateProvince = $('#state-province-b').val();

			if (membershipID !== '' && stateProvince !== '') {
				$.ajax({
					method: "POST",
					url: "/h/book/ApplyMembershipPrice",
					dataType: 'JSON',
					data: { membershipID: membershipID, stateProvince: stateProvince },
				})
				.done(function( data ) {
					// Success - Process
					$('.js-membership-price').html(data.membershipOriginalPrice);
					$('.js-subtotal-price').html(data.membershipPrice);
					$('.js-membership-tax-cost').html(data.membershipTaxCost);
					$('.js-membership-total-price').html(data.membershipTotalPrice);

					if (data.displayDiscount === 'true') {
						$('.js-discount-amount').html('-' + data.membershipPriceDiscount);
						$('.js-price-discount').show();
					} else {
						$('.js-discount-amount').html('0.00');
						$('.js-price-discount').hide();
					}

					recalculateGrandTotalPrice();
					
					if ($status === 'state') {
						launchInfoDialog("Your 'Billing State' has been updated and the Trip Summary has been updated to reflect the new Taxes.");
					} else {
						var $upgradeText = $('input[name="membership-id"]:checked').parent().text();
						//launchInfoDialog("The Premium " + $upgradeText + " has been applied.");
					}
				})
				.fail(function() {
					alert( "An unexpected error has occurred." );
				});
			}
			else {
				launchInfoDialog("To calculate your Premium Membership Upgrade cost, your Billing State / Province is required.");

				// Set the radio membership to the default / 1st value
				$("input[name=membership-id][value='3']").prop('checked', true);
			}
		}

		function recalculateGrandTotalPrice() {
			// Main fn to re-calculate the grand total value

			var membershipTotalPrice = '';
			$('.js-membership-total-price').each(function(index, obj){
				// grab the last class value
				membershipTotalPrice = $(this).text();
			});
			membershipTotalPriceNum = membershipTotalPrice.replace("$", "");
			
			if(membershipTotalPriceNum !== "") {
				// Premium Membership Price feature turned on, proceed to calculate.

				finalPrice = getFinalPrice();
				finalPriceNum = finalPrice.replace("$", "");
				//alert("finalPriceNum: " + finalPriceNum);

				//alert("membershipTotalPriceNum: " + membershipTotalPriceNum);

				grandTotalPrice = Number(finalPriceNum) + Number(membershipTotalPriceNum);
				grandTotalPriceNum = parseFloat(grandTotalPrice, 10).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
				//alert("grandTotalPrice: " + grandTotalPriceNum);

				// Set the Grand Total Price
				$('.js-grand-total-price').html("$" + grandTotalPriceNum);
			}
		}
	});
});

jQuery(function initHandleBookingStep2Form($) {
	$('#form-booking-step-2').each(function(index, el) {

		var $container = $(this);
		var $submitBtn = $container.find('.btn-submit');

		$submitBtn.click(function() {
			// Diaplay a lDialog loading shadow box
			checkValidityValue = $('#form-booking-step-2')[0].checkValidity(); // returns true/false
		
			if(checkValidityValue === true) {
				// Browser checkValidity is true, load loading ldialog shadow box
				launchLoadingDialog();
				
				setTimeout(function(){
					$("#form-booking-step-2").submit();
				},1000);
			}
		});
	});
});


function refreshPeerIframeSrc(creditCardTypes) {
	// Pass in the credit card types based on apply or remove of the promocode
	//alert("Refresh Peer iframe");
	var peerIframeSrc = document.getElementById('peer-iframe').src;
	var peerIframeCln = peerIframeSrc.replace(/&?creditCardTypes=([^&]$|[^&]*)/i, "");
	//alert("Clean peer Iframe src: " + peerIframeCln);
	//alert("iframe src: " + peerIframeCln + '&creditCardTypes=' + creditCardTypes);
	document.getElementById('peer-iframe').src = peerIframeCln + '&creditCardTypes=' + creditCardTypes;
}